<div nxLayout="grid maxwidth" class="policy-detail" *ngIf="policy">
    <div nxRow>
        <div nxCol="12">
            <nx-link class="go-back">
                <a routerLink='/moje-poistky'>
                    <nx-icon name='chevron-left'></nx-icon>
                    {{'policy.go-back' | translate}}
                </a>
            </nx-link>
        </div>
    </div>
    <div nxRow>
        <div nxCol="12">
            <cpc-policy-card [ngClass]="policy.policyState.name" [variant]="policy.policyState.badge">
                <cpc-policy-card-header class="cpc-policy-card-header_{{policy.policyState.badge}}">
                    <cpc-icon left [icon]="policy.groupIcon"
                        color="{{ (policy.isElectricVehicle) ? '#3da556' : '#006192' }}" borderStyle="circle"
                        backgroundColor="#fff">
                    </cpc-icon>
                    <ng-container center>
                        <p translate *ngIf="!policy.isElectricVehicle">
                            {{'active-insurance-group.' + policy.groupName}}</p>
                        <p translate *ngIf="policy.isElectricVehicle">
                            {{'active-insurance-group.car-insurance-ek'}}</p>
                        <p class="nameLine">
                            <container-element [ngSwitch]="LOB.setId(policy.lineOfBusinessId).lob">
                                <h2 *ngSwitchCase="lob.CarInsurance">{{policy.model |
                  stringFormat}}&nbsp;- {{policy.crn |
                  stringFormat}}</h2>
                                <h2 *ngSwitchCase="lob.LifeInsurance">{{policy.firstInsuredName
                  | stringFormat}}</h2>
                                <h2 *ngSwitchCase="lob.HomeInsurance">{{policy.householdAddress
                  | stringFormat}}</h2>
                            </container-element>
                            <cpc-badge [variant]="policy.policyState.badge">
                                {{'product-state.' + policy.policyState.name | translate}}
                                <cpc-icon icon="check-circle" color="#3DA556"></cpc-icon>
                            </cpc-badge>
                        </p>
                    </ng-container>
                    <ng-container right>
                    </ng-container>
                </cpc-policy-card-header>
                <cpc-policy-card-content class="policy-card-content">
                    <div nxRow>
                        <div nxCol="12, 12, 12, 6">
                            <cpc-policy-card-entry>
                                <span title translate>home.product-name</span>
                                <b>{{policy.productNameSpecific | stringFormat}}</b>
                            </cpc-policy-card-entry>
                            <cpc-policy-card-entry>
                                <span title translate>policy.policy-number</span>
                                <b>{{policy.policyNumber | stringFormat}}</b>
                            </cpc-policy-card-entry>
                        </div>
                        <div nxCol="12, 12, 12, 6"
                            *ngIf="!(policy.detailTypeIdentifier.toLowerCase() == lob.CarInsurance && policy.leasFleetFlag == true)">
                            <cpc-policy-card-entry>
                                <span title translate>policy.total-premium-amount</span>
                                <b>{{policy.annualPaidPremium | stringFormat | currencyFormat :
                  policy.premiumCurrency}}</b>
                            </cpc-policy-card-entry>
                            <cpc-policy-card-entry>
                                <span title translate>policy.instalment-amount</span>
                                <b class="termPremium">{{policy.termPremium | stringFormat |
                  currencyFormat : policy.premiumCurrency}}</b>
                                <app-payment-frequency class="payment-frequency"
                                    [paymentFrequencyId]="policy.paymentFrequencyId">
                                </app-payment-frequency>
                            </cpc-policy-card-entry>

                            <cpc-policy-card-entry class="payment-frequency">
                                <app-payment-frequency [paymentFrequencyId]="policy.paymentFrequencyId">
                                </app-payment-frequency>
                            </cpc-policy-card-entry>
                        </div>
                    </div>
                    <ng-template [ngIf]="!!policy.endDate">
                        <div class="policy-progress">
                            <cpc-policy-progress [startDate]="policy.beginDate" [endDate]="policy.endDate"
                                [isActiveBar]="policy.policyState === policyStates.active"
                                copyStart="{{'policy.start-date' | translate}}"
                                copyEnd="{{'policy.end-date' | translate}}">
                            </cpc-policy-progress>
                        </div>
                    </ng-template>
                    <ng-template [ngIf]="!policy.endDate">
                        <div nxRow>
                            <div nxCol="12, 12, 12, 6">
                                <cpc-policy-card-entry>
                                    <span title translate>policy.start-date</span>
                                    <b>{{policy.beginDate | dateFormat}}</b>
                                </cpc-policy-card-entry>
                            </div>
                        </div>
                    </ng-template>
                </cpc-policy-card-content>

                <cpc-policy-card-content class="button-row">
                    <nx-accordion variant="extra-light" *ngIf="selectedCorrespondence.length > 0">
                        <nx-expansion-panel>
                            <nx-expansion-panel-header>
                                <nx-expansion-panel-title>{{'policy.show-documents' |
                  translate}}</nx-expansion-panel-title>
                            </nx-expansion-panel-header>
                            <div class="documents-dropdown">
                                <app-correspondence-simple-list [correspondenceList]="selectedCorrespondence"
                                    [downLoadDocumentUrl]="downLoadDocumentUrl">
                                </app-correspondence-simple-list>
                            </div>
                        </nx-expansion-panel>
                    </nx-accordion>


                    <button nxPlainButton type="button" class="file-a-claim" (click)="insuredTripsRedir()">
                        {{'policy.insured-trips.title' | translate}}<nx-icon name="launch"
                            class="nx-margin-left-2xs"></nx-icon>
                    </button>

                    <button nxPlainButton type="button" class="file-a-claim" (click)="employeesRedir()">
                        {{'policy.employees.title' | translate}}<nx-icon name="manager"
                            class="nx-margin-left-2xs"></nx-icon>
                    </button>

                </cpc-policy-card-content>
            </cpc-policy-card>
        </div>
    </div>

    <div nxRow class="my-payments" *ngIf="showPayments">
        <div nxCol="12">
            <h3 nxHeadline="subsection-medium" translate class="title">
                policy.my-payments</h3>
            <nx-tab-group (selectedTabChange)="paymentsTabChanged($event)" [(selectedIndex)]="paymentsTabIndex">
                <nx-tab [label]="'policy.payments.upcoming' | translate">
                    <nx-card>
                        <div nxRow class="tab-content" data-type="upcoming">
                            <app-premium-list-paged [premiumList]="upcomingPaymentList"
                                [variant]="paymentStatus.upcoming">
                            </app-premium-list-paged>
                            <div class="payment-method">
                                <div class="payment-headline">
                                    <h4 nxHeadline="subsection-xsmall" translate>
                                        policy.payments.payment-method
                                    </h4>
                                    <cpc-button size="small" mode="tertiary" (click)="openLink('edit-payment')"
                                        *ngIf="policy.policyState.badge!='inactive'">
                                        <nx-icon name="edit" class="nx-margin-left-2xs"></nx-icon>
                                        {{ "popup.payment-method.editBtn" |
                    translate }}
                                    </cpc-button>
                                </div>
                                <div nxRow>
                                    <div nxCol="12, 12, 12, 6">
                                        <cpc-policy-card-entry>
                                            <span title translate>policy.payments.payment-method</span>
                                            <b>{{paymentModes.findById(policy.paymentMethodId)?.textToTranslate
                        | translate}}</b>
                                        </cpc-policy-card-entry>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nx-card>
                </nx-tab>
                <nx-tab [label]="'policy.payments.past' | translate">
                    <nx-card>
                        <div nxRow class="tab-content" data-type="past">
                            <app-premium-list-paged [premiumList]="pastPaymentList" [variant]="paymentStatus.past">
                            </app-premium-list-paged>
                        </div>
                    </nx-card>
                </nx-tab>
            </nx-tab-group>
        </div>
    </div>

    <app-ma-insurance [agentSource]="agentSource" [policy]="policy" [maInsurance]="maInsurance"
        [showEdit]="policy.policyState.badge=='inactive'?false:true"></app-ma-insurance>

    <div nxRow class="documents">
        <div nxCol="12">
            <h3 nxHeadline="subsection-medium" translate>policy.list-of-documents</h3>
        </div>
        <!--
    <div nxCol="12,12,12,3">
      <nx-card class="download-all-card">
        <cpc-illustration name="manHoldingCertificate" width="136px">
        </cpc-illustration>
        <h4 nxHeadline="subsection-small" translate>policy.download-all.text
        </h4>
        <cpc-button (click)="downloadAll()" [noHorizontalMargin]="true"
          [noVerticalMargin]="true" size="small" mode="secondary"
          [disabled]="(this.disableButtonDownloadAllArr.includes(policy.downloadAllStatus.status)||this.clickedDownloadSuccess)?true:false">
          {{ 'policy.download-all.btnText.'+policy.downloadAllStatus.status |
          translate }}</cpc-button>
      </nx-card>
    </div>-->
        <div nxCol="12,12,12,12">

            <nx-card>
                <ng-template [ngIf]="!!groupedCorrespondence && groupedCorrespondence.length > 0" [ngIfElse]="noData">
                    <div *ngFor="let group of groupedCorrespondence">
                        <cpc-documents [title]="group.correspondenceList[0][0].classidLabel">
                            <app-correspondence [correspondenceList]="group.correspondenceList"
                                [downLoadDocumentUrl]="downLoadDocumentUrl">
                            </app-correspondence>
                        </cpc-documents>
                    </div>
                </ng-template>
                <ng-template #noData>
                    <div class="no-data" translate>policy.no-documents</div>
                </ng-template>
            </nx-card>
        </div>
    </div>
</div>